import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'src/common/refactoredComponents/select/Select';
import {
    Title,
    ProcedureDropdownContainer,
    ProcedureContainer,
} from './ProcedureDropdown.styled';
import { Text } from '../../../../header/ReportUsageHeader.styled';
import { VISIBLE } from 'src/constants/appConstants';
import Pediatric from '../../../../../../common/components/PediatricContainer/Pediatric';
import { BASE_TEXT_PX, FONT_FAMILY_REGULAR, PRIMARY_FONT_COLOR} from 'src/styles/fonts/MCFontConstants';
const ProcedureDropdown = ({
    dropDownValue,
    setDropDownValue,
    proceduresList,
    marginBottom,
    ProcedureMarginBottom,
    procedureValue,
    procedureDataPhysician,
    isDraft,
    procedureMandatoryRule = false,
    isDisabledPediatric,
    setPediatricCheck = () => {},
    isPediatricSurgery,
    isFromProcedure,
    pediatricMandatoryRule,
    pediatricSurgeryVisibility,
    isFromEquity,
    showProcedureDropdown
}) => {
    const { t } = useTranslation();
    const hasValidValues = (obj) => {
         return obj && Object.values(obj).every(value => value !== undefined);
    };
    const selectValue = isDraft 
                ? (hasValidValues(procedureValue) ? procedureValue : null)
                : (hasValidValues(dropDownValue) ? dropDownValue : null);

    return (
        <>
            {showProcedureDropdown && (
                <ProcedureDropdownContainer
                    marginBottom={marginBottom && !pediatricSurgeryVisibility}
                    isPhysician={
                        procedureDataPhysician && !pediatricSurgeryVisibility
                    }
                >
                    <ProcedureContainer
                        marginBottom={
                            procedureValue &&
                            !isDraft &&
                            !pediatricSurgeryVisibility
                                ? procedureDataPhysician
                                    ? '0px'
                                    : '10px'
                                : procedureDataPhysician
                                ? ProcedureMarginBottom
                                : pediatricSurgeryVisibility
                                ? '0px'
                                : '20px'
                        }
                    >
                        <Title
                            showAstrisk={procedureMandatoryRule}
                            isFromProcedure={isFromProcedure || isFromEquity}
                            isProcedureValue={
                                procedureValue?.procedureCode?.length > 0
                            }
                        >
                            {t('common.procedureLabel')}
                        </Title>
                    </ProcedureContainer>
                    {procedureValue?.procedureCode?.length > 0 && !isDraft ? (
                        <Text
                            color={PRIMARY_FONT_COLOR}
                            fontFamily={FONT_FAMILY_REGULAR}
                            textAlign={true}
                            fontSize={BASE_TEXT_PX}
                        >
                            {procedureValue?.procedureDescription}
                        </Text>
                    ) : (
                        <Select
                            id="reportUsage-index-procedure-selectProcedure"
                            value={selectValue}
                            options={proceduresList ? proceduresList : []}
                            onChange={val => {  
                                val === undefined && isFromEquity ? setDropDownValue(null, true) : setDropDownValue(val, false); 
                            }}                            
                            isFromProcedure={true}
                            iPadwidth={'95%'}
                            placeholder={t('common.selectProcedure')}
                            optionLabel="procedureDescription"
                            hideClear={isFromEquity ? Object.prototype.hasOwnProperty.call(selectValue,'procedureCode') ? selectValue?.procedureCode==='' ? true : false : true : false}
                        />
                    )}
                </ProcedureDropdownContainer>
            )}
            {pediatricSurgeryVisibility && (
                <Pediatric
                    isFromProcedure={isFromProcedure}
                    isFromEquity={isFromEquity}
                    isPediatricSurgery={isPediatricSurgery}
                    setPediatricCheck={setPediatricCheck}
                    isDisabledPediatric={isDisabledPediatric}
                    procedureText={
                        procedureValue?.procedureCode?.length > 0 && !isDraft
                    }
                    pediatricMandatoryRule={pediatricMandatoryRule}
                />
            )}
        </>
    );
};

export default ProcedureDropdown;
